// src/services/EntityService.js

import axios from 'axios';
import config from '../config';

const EntityService = {
  getAll: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/entities`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  get: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/entities/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  create: async (data) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${config.apiBaseUrl}/entities`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  update: async (id, data) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${config.apiBaseUrl}/entities/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  delete: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${config.apiBaseUrl}/entities/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },
};

export default EntityService;
